module.exports = __webpack_public_path__ + "img/Inspection7.fd785682.png";